export default import.meta.ROLLUP_FILE_URL_mUdN8$i2b$ZFy3ldtf4jcQ;